import pvfs from './pvfs'

class NewslettersPermissionsManager {
  protected pvfs: string[]

  constructor(pvfs: string[] = []) {
    this.pvfs = pvfs
  }

  scope(params: any) {
    // To do: Scope based on groups.
    // This is not required for MVP, as there will only be one team.
    return params
  }

  canCreate() {
    return this.isAdmin() || this.isCreator()
  }

  canEdit() {
    return this.isAdmin() || this.isEditor()
  }

  canRead() {
    return this.isAdmin() || this.isReader()
  }

  isAdmin() {
    const stagingAdmin = (process.env.NODE_ENV as string) === 'staging' && this.pvfs.includes(pvfs.ADMIN_STAGING)
    return this.pvfs.includes(pvfs.ADMIN) || stagingAdmin
  }

  isReader() {
    return this.pvfs.includes(pvfs.NEWSLETTER_VIEW)
  }

  isCreator() {
    return this.pvfs.includes(pvfs.NEWSLETTER_CREATE)
  }

  isEditor() {
    return this.pvfs.includes(pvfs.NEWSLETTER_EDIT)
  }
}

export default NewslettersPermissionsManager
